import React, { useState } from "react";
import TableTopActions from "../../../components/crm/tables/TableTopActions";
import { useLocation } from "react-router-dom";
import { getColumns } from "../../../components/crm/tables/Columns";
import { getData } from "../../../components/crm/dummyData";
import EntityFormModal from "../../../components/crm/forms/EntityFormModal";
import SelectionActionsModal from "../../../components/crm/forms/SelectionActionsModal";
import { FormattedMessage } from "react-intl";
import { ReactComponent as ClientsImg } from "../../../assets/no-clients.svg";
import { Table, Empty } from "antd";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import CrmTemplate from "../../../components/crm/CrmTemplate";

var flatten = require("flat");

const Campaigns = () => {
  const intl = useIntl();
  let location = useLocation();
  const dispatch = useDispatch();
  const [entityModalVisible, setEntityModalVisible] = useState(false);
  const [selectionActionModalVisible, setSelectionActionModalVisible] =
    useState(false);
  const [selectionActionLoading, setSelectionActionLoading] = useState(false);
  const [selectionAction, setSelectionAction] = useState(null);

  const [activeRecord, setActiveRecord] = useState(null);
  const [mode, setMode] = useState("new");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const items = getData("campaigns");

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const loading = false;

  const onLaunchEntityModal = (record, val) => {
    if (record) {
      const flattenItem = flatten(record, { safe: true });
      setActiveRecord(flattenItem);
    }
    setEntityModalVisible(true);
    setMode(val);
  };

  const hideLeadModal = () => {
    setEntityModalVisible(false);
    // dispatch(reload());
    setActiveRecord(null);
  };

  const onLaunchSelectionActionModal = (source) => {
    setSelectionAction(source);
    setSelectionActionModalVisible(true);
  };

  const hideSelectionActionModal = () => {
    setSelectionActionModalVisible(false);
    // dispatch(reload());
  };

  return (
    <CrmTemplate>
      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "10px",
          margin: "10px",
          boxShadow: "0 4px 9px 0 rgba(0, 0, 0, 0.05)",
          borderRadius: "5px",
        }}
      >
        <TableTopActions
          newAction={onLaunchEntityModal}
          selectionAction={onLaunchSelectionActionModal}
          keys={selectedRowKeys}
          entity={"campaigns"}
        />
        <Table
          loading={loading}
          rowKey={(record) => record.id}
          columns={getColumns("campaigns", intl, location, dispatch, {
            onLaunchEntityModal,
          })}
          dataSource={items}
          scroll={{
            y: window.innerHeight - 426,
          }}
          bordered
          locale={{
            emptyText: (
              <Empty
                image={!loading ? <ClientsImg /> : null}
                description={
                  !loading ? (
                    <FormattedMessage id={"app.tables.noData"} />
                  ) : null
                }
              />
            ),
          }}
          rowSelection={rowSelection}
        />
        <EntityFormModal
          visible={entityModalVisible}
          record={activeRecord}
          hide={hideLeadModal}
          mode={mode}
          entity={"campaigns"}
        />
        <SelectionActionsModal
          visible={selectionActionModalVisible}
          hide={hideSelectionActionModal}
          loading={selectionActionLoading}
          keys={selectedRowKeys}
          entity={"campaigns"}
          selectionAction={selectionAction}
        />
      </div>
    </CrmTemplate>
  );
};
export default Campaigns;
